<template lang="">
  <div>
    <page-header
      :page="headerPage"
      :actions="headerActions"
      left-side-class="col-xl-8"
      right-side-class="col-xl-4 d-flex align-items-end justify-content-end pb-2"
    />
    <section-title
      has-line
      content="Editar Equipo"
      container-class="tag-badge-info-custom"
    />
    <div class="row bg-gray p-4 m-0">
      <validation-observer tag="form" ref="observer" class="w-100">
        <div class="col-12">
          <div class="row">
            <div class="col-12 mb-3">
              <icon-view
                :has-border="false"
                icon="fas fa-info-circle text-orange"
                variant="custom-icon-view"
                icon-background="white"
                title="Información de Nuevo Sub-Equipo"
              />
            </div>
            <div class="col-12 col-lg-4">
              <div class="form-group">
                <validation-provider
                  mode="eager"
                  :rules="'required'"
                  v-slot="{ errors }"
                >
                  <div class="data-label mb-2">
                    Nombre de Equipo MiPE:
                  </div>
                  <input
                    :value="equipment.catalogName"
                    :error="errors[0]"
                    type="text"
                    disabled
                    class="form-control"
                  />
                </validation-provider>
              </div>
            </div>
            <div class="col-12 col-lg-4">
              <div class="form-group">
                <validation-provider
                  mode="eager"
                  :rules="'required'"
                  v-slot="{ errors }"
                >
                  <custom-input
                    v-model="model.nameOfEquipment"
                    type="text"
                    label="Nombre de Equipo:"
                    :custom-error-msg="'Este campo es requerido'"
                    :error="errors[0]"
                  />
                </validation-provider>
              </div>
            </div>
            <div class="col-12 col-lg-4">
              <div class="form-group">
                <custom-drop-down
                  v-model="model.caat"
                  :options="caats"
                  label="CAAT:"
                  fieldkey="id"
                  fieldname="name"
                  placeholder="Seleccione"
                  class="w-100 mb-4 bold-label"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-lg-4">
              <div class="form-group">
                <validation-provider
                  mode="eager"
                  :rules="'required'"
                  v-slot="{ errors }"
                >
                  <custom-input
                    v-model="model.location"
                    type="text"
                    label="Datos de Ubicación / Dirección:"
                    :custom-error-msg="'Este campo es requerido'"
                    :error="errors[0]"
                  />
                </validation-provider>
              </div>
            </div>
            <div class="col-12 col-lg-4">
              <div class="form-group">
                <validation-provider
                  v-slot="{ errors }"
                  mode="eager"
                  rules="required"
                >
                  <custom-drop-down
                    v-model="model.status"
                    :options="inventoryTypes"
                    label="Estado del Equipo:"
                    fieldkey="id"
                    fieldname="name"
                    placeholder="Seleccione"
                    class="w-100 mb-4 bold-label"
                    custom-error-msg="Este campo es requido"
                    :error="errors[0]"
                  />
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <validation-provider v-slot="{ errors }" rules="required">
                  <div class="color-black font-14 my-1">
                    Descripción de Equipo:
                  </div>
                  <custom-text-area
                    v-model="model.description"
                    id="txtComment"
                    :count-classes="['d-block', 'small-counter', 'text-right']"
                    custom-error-msg="Favor escriba un comentario"
                    :error="errors[0]"
                    :maxlength="3000"
                    placeholder="Describa las características del Equipo"
                    show-char-count
                  />
                </validation-provider>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-12 mb-3">
              <icon-view
                :has-border="false"
                icon="fas fa-plus-circle text-orange"
                icon-size="16px"
                variant="custom-icon-view"
                icon-background="white"
                title="Propiedades"
              />
            </div>
            <div class="col-12 col-lg-4">
              <div class="form-group">
                <validation-provider v-slot="{ errors }" mode="eager">
                  <custom-drop-down
                    v-model="model.brand"
                    :options="brandOptions"
                    label="Marca:"
                    fieldkey="id"
                    fieldname="name"
                    placeholder="Seleccione"
                    class="w-100 mb-4 bold-label"
                    custom-error-msg="Favor seleccione una marca"
                    :error="errors[0]"
                    @input="() => (model.model = null)"
                  />
                </validation-provider>
              </div>
            </div>
            <div class="col-12 col-lg-4">
              <div class="form-group">
                <validation-provider v-slot="{ errors }" mode="eager">
                  <custom-drop-down
                    v-model="model.model"
                    :options="modelOptions"
                    label="Modelo:"
                    fieldkey="id"
                    fieldname="name"
                    placeholder="Seleccione"
                    class="w-100 mb-4 bold-label"
                    custom-error-msg="Favor seleccione un modelo"
                    :error="errors[0]"
                  />
                </validation-provider>
              </div>
            </div>
            <div class="col-12 col-lg-4">
              <div class="form-group">
                <validation-provider v-slot="{ errors }" mode="eager">
                  <custom-drop-down
                    v-model="model.color"
                    :options="colorOptions"
                    label="Color:"
                    fieldkey="id"
                    fieldname="name"
                    placeholder="Seleccione"
                    class="w-100 mb-4 bold-label"
                    custom-error-msg="Favor seleccione un color"
                    :error="errors[0]"
                  />
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-lg-4">
              <div class="form-group">
                <validation-provider v-slot="{ errors }" mode="eager">
                  <custom-drop-down
                    v-model="model.size"
                    :options="sizeOptions"
                    label="Tamaño:"
                    fieldkey="id"
                    fieldname="name"
                    placeholder="Seleccione"
                    class="w-100 mb-4 bold-label"
                    custom-error-msg="Favor seleccione un tamaño"
                    :error="errors[0]"
                  />
                </validation-provider>
              </div>
            </div>
            <div
              class="col-12 col-lg-4"
              v-for="(prop, index) in otherProperties"
              :key="index"
            >
              <div class="form-group">
                <validation-provider v-slot="{ errors }" mode="eager">
                  <custom-drop-down
                    v-model="prop.model"
                    :options="
                      prop.details.map((detail) => ({
                        id: detail.id,
                        name: detail.name,
                      }))
                    "
                    :label="`${prop.name}:`"
                    fieldkey="id"
                    fieldname="name"
                    placeholder="Seleccione"
                    class="w-100 mb-4 bold-label"
                    :custom-error-msg="`Favor seleccione una ${prop.name}`"
                    :error="errors[0]"
                  />
                </validation-provider>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <div class="col-12">
        <div class="row">
          <div class="col-12 mb-3">
            <icon-view
              :has-border="false"
              icon="fas fa-plus-circle text-orange"
              icon-size="16px"
              variant="custom-icon-view"
              icon-background="white"
              title="Accesorios"
            />
          </div>
          <div class="col-12 col-lg-3 mr-5">
            <validation-observer ref="accesoryForm">
              <div class="row border-right pr-5">
                <div class="col-12 mb-2">
                  <div class="color-black font-16 my-1 font-weight-bold">
                    Seleccione Accesorio(s):
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <validation-provider
                      v-slot="{ errors }"
                      mode="eager"
                      rules="required"
                    >
                      <custom-drop-down
                        v-model="currentCategory"
                        :options="categoryOptions"
                        label="Categoría:"
                        fieldkey="id"
                        fieldname="name"
                        placeholder="Seleccione"
                        class="w-100 mb-4 bold-label"
                        custom-error-msg="Favor seleccione una categoría"
                        :error="errors[0]"
                      />
                    </validation-provider>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <validation-provider
                      v-slot="{ errors }"
                      mode="eager"
                      rules="required"
                    >
                      <custom-drop-down
                        v-model="currentAccessory"
                        :options="accessoryOptions"
                        label="Accesorio:"
                        fieldkey="id"
                        fieldname="name"
                        placeholder="Seleccione"
                        class="w-100 mb-4 bold-label"
                        custom-error-msg="Favor seleccione una accesorio"
                        :error="errors[0]"
                      />
                    </validation-provider>
                  </div>
                </div>
                <div class="col-12">
                  <action-button
                    variant="success float-right"
                    text="Añadir"
                    i="fas fa-file-medical"
                    @click="addingAccessory"
                  />
                </div>
              </div>
            </validation-observer>
          </div>
          <div class="col-12 col-lg">
            <div class="row">
              <div class="col-12 mb-4">
                <div class="data-label">
                  Accesorio(s) Seleccionado(s):
                </div>
              </div>
              <div
                class="col-12 col-lg-3 bg-white rounded d-flex justify-content-between p-2 mr-2 mb-2"
                v-for="(accessory, index) in selectedAccessories"
                :key="index"
              >
                <div>
                  <p class="font-16 font-weight-bold mb-0">
                    {{ accessory.category.name }}
                  </p>
                  <p class="font-14">
                    <span class="text-muted">
                      {{ accessory.accessory.name }}
                    </span>
                    -
                    <span>
                      {{ accessory.accessory.model }}
                    </span>
                  </p>
                </div>
                <div class="d-flex justify-content-center align-items-center">
                  <i
                    class="far fa-times-circle cursor-pointer color-red pt-1"
                    @click="() => handlerRemoveAcc(accessory, index)"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PageHeader from 'PageHeader';
import SectionTitle from 'SectionTitle';
import IconView from 'icon-view';
import CustomInput from 'CustomInput';
import CustomDropDown from 'custom-drop-down';
import CustomTextArea from '@quisit/custom-text-area';
import ActionButton from 'ActionButton';
import PurchaseMethodInventoryTypes from '@/utils/constants/purchaseMethodInventoryTypes';
import inventoryCatalogService from '@/services/api/inventorycatalog.api';
import locationService from '@/services/api/location.api';
import mixAlert from '@/mixins/alert.mixin';

const PROPERTY_BRAND_NAME = 'Marca';
const PROPERTY_MODEL_NAME = 'Modelo';
const PROPERTY_COLOR_NAME = 'Color';
const PROPERTY_SIZE_NAME = 'Tamaño';

export default {
  name: 'InventoryMaintenanceEquipmentEdit',
  components: {
    PageHeader,
    SectionTitle,
    IconView,
    CustomInput,
    CustomDropDown,
    CustomTextArea,
    ActionButton,
  },
  mixins: [mixAlert],
  data() {
    return {
      equipment: {},
      properties: [],
      accessories: [],
      caats: [],
      currentCategory: null,
      currentAccessory: null,
      selectedAccessories: [],
      model: {
        nameOfEquipment: '',
        caat: null,
        location: '',
        status: null,
        description: '',
        brand: null,
        model: null,
        color: null,
        size: null,
      },
    };
  },
  computed: {
    headerPage() {
      return {
        icon: 'fas fa-laptop',
        title: `Editar Equipo: ${this.equipment.catalogName}`,
        routes: [
          'Inicio',
          'Inventario',
          'Mantenimiento del Catálogo de Equipos de Asistencia Tecnológica',
        ],
      };
    },
    headerActions() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left',
          variant: 'outline-success',
          click: () => this.goBack(),
        },
        {
          text: 'Guardar',
          icon: 'fas fa-save',
          variant: 'success',
          click: () => this.save(),
        },
      ];
    },
    inventoryCatalogId() {
      return Number(this.$route.params.id);
    },
    equipmentId() {
      return Number(this.$route.params.equipmentId);
    },
    brandOptions() {
      return (
        this.properties
          .find((property) => property.name === PROPERTY_BRAND_NAME)
          ?.details.map((brand) => ({
            id: brand.id,
            name: brand.name,
            options: brand.children,
          })) || []
      );
    },
    modelOptions() {
      const brand = this.model.brand;
      const models = this.brandOptions.find(
        (property) => property.id === (brand || {}).id
      );

      const items = models?.options.map((item) => ({
        id: item.id,
        name: item.name,
      }));

      return items || [];
    },
    colorOptions() {
      return (
        this.properties
          .find((property) => property.name === PROPERTY_COLOR_NAME)
          ?.details.map((color) => ({
            id: color.id,
            name: color.name,
            ...color,
          })) || []
      );
    },
    sizeOptions() {
      return (
        this.properties
          .find((property) => property.name === PROPERTY_SIZE_NAME)
          ?.details.map((size) => ({
            id: size.id,
            name: size.name,
            ...size,
          })) || []
      );
    },
    otherProperties() {
      return this.properties
        .filter(
          (property) =>
            ![
              PROPERTY_BRAND_NAME,
              PROPERTY_MODEL_NAME,
              PROPERTY_COLOR_NAME,
              PROPERTY_SIZE_NAME,
            ].includes(property.name)
        )
        .map((e) => {
          const prop = this.equipment.properties.find((y) => y.id === e.name);
          const model = prop
            ? { id: Number(prop.value), name: prop.name }
            : null;
          return { ...e, model };
        });
    },
    inventoryTypes() {
      return [
        {
          id: PurchaseMethodInventoryTypes.New,
          name: 'Nuevo',
        },
        {
          id: PurchaseMethodInventoryTypes.Used,
          name: 'Usado',
        },
        {
          id: PurchaseMethodInventoryTypes.Auction,
          name: 'Subasta',
        },
      ];
    },
    categoryOptions() {
      return this.accessories.map((accessory) => ({
        id: accessory.id,
        name: accessory.name,
      }));
    },
    accessoryOptions() {
      const category = this.currentCategory;
      const accessory = this.accessories.find(
        (acc) => acc.id === (category || {}).id
      );

      const items = accessory?.details
        .map((detail) => ({
          id: detail.id,
          name: detail.name,
          model: detail.model,
        }))
        .filter(
          (item) =>
            !this.selectedAccessories.some((x) => x.accessory.id === item.id)
        );

      return items || [];
    },
  },
  async mounted() {
    await this.getData();
    await Promise.all([
      this.getProperties(),
      this.getCaats(),
      this.getAccessories(),
    ]);
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    async getData() {
      const { data } = await inventoryCatalogService.getEquipmentDetails(
        this.equipmentId
      );
      this.equipment = data;

      this.model = {
        nameOfEquipment: this.equipment.name,
        caat: this.equipment.caatId
          ? { id: this.equipment.caatId, name: this.equipment.caat }
          : null,
        location: this.equipment.address,
        status: {
          id: this.equipment.equipmentStatusId,
          name: this.equipment.equipmentStatus,
        },
        description: this.equipment.description,
      };
      const brand = this.equipment.properties.find(
        (x) => x.id === PROPERTY_BRAND_NAME
      );
      if (brand)
        this.model.brand = { id: Number(brand.value), name: brand.name };

      const model = this.equipment.properties.find(
        (x) => x.id === PROPERTY_MODEL_NAME
      );
      if (model)
        this.model.model = { id: Number(model.value), name: model.name };

      const color = this.equipment.properties.find(
        (x) => x.id === PROPERTY_COLOR_NAME
      );
      if (color)
        this.model.color = { id: Number(color.value), name: color.name };

      const size = this.equipment.properties.find(
        (x) => x.id === PROPERTY_SIZE_NAME
      );
      if (size) this.model.size = { id: Number(size.value), name: size.name };

      this.equipment.accessoriesDetails.forEach((x) => {
        const payload = {
          category: { id: x.id, name: x.name },
          accessory: {
            id: x.detailId,
            name: x.detailName,
            model: x.detailModel,
          },
        };

        this.selectedAccessories.push(payload);
      });
    },
    async getProperties() {
      const { data } = await inventoryCatalogService.getProperties(
        this.inventoryCatalogId
      );
      this.properties = data;
    },
    async getAccessories() {
      const { data } = await inventoryCatalogService.getAccessories(
        this.inventoryCatalogId
      );
      this.accessories = data;
    },
    async getCaats() {
      const { data: caats } = await locationService.getCaats();
      this.caats = caats;
    },
    async addingAccessory() {
      const isValid = await this.$refs.accesoryForm.validate();
      if (!isValid) {
        return;
      }
      const payload = {
        category: this.currentCategory,
        accessory: this.currentAccessory,
      };

      this.selectedAccessories.push(payload);
      this.currentCategory = null;
      this.currentAccessory = null;
      this.$refs.accesoryForm.reset();
    },
    handlerRemoveAcc(accessory, index) {
      this.selectedAccessories.splice(index, 1);
    },
    async save() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return;
      }

      let properties = [];

      if (this.otherProperties.length > 0) {
        const inputOtherProps = this.otherProperties
          .filter((x) => x.model != null)
          .map((prop) => ({
            propertyId: prop.id,
            propertyDetailId: prop.model.id,
          }));
        if (inputOtherProps.length > 0) {
          properties = [...inputOtherProps];
        }
      }

      if (this.model.brand != null && this.model.brand != undefined) {
        properties.push({
          propertyId: this.properties.find(
            (prop) => prop.name === PROPERTY_BRAND_NAME
          ).id,
          propertyDetailId: this.model.brand.id,
        });
      }

      if (this.model.model != null && this.model.model != undefined) {
        properties.push({
          propertyId: this.properties.find(
            (prop) => prop.name === PROPERTY_MODEL_NAME
          ).id,
          propertyDetailId: this.model.model.id,
        });
      }

      if (this.model.color != null && this.model.color != undefined) {
        properties.push({
          propertyId: this.properties.find(
            (prop) => prop.name === PROPERTY_COLOR_NAME
          ).id,
          propertyDetailId: this.model.color.id,
        });
      }

      if (this.model.size != null && this.model.size != undefined) {
        properties.push({
          propertyId: this.properties.find(
            (prop) => prop.name === PROPERTY_SIZE_NAME
          ).id,
          propertyDetailId: this.model.size.id,
        });
      }

      const payload = {
        catalogId: this.inventoryCatalogId,
        name: this.model.nameOfEquipment,
        statusId: this.model.status.id,
        caatId: this.model.caat?.id,
        address: this.model.location,
        description: this.model.description,
        accessories: this.selectedAccessories.map((acc) => ({
          equipmentId: acc.category.id,
          accessoryDetailId: acc.accessory.id,
        })),
        properties,
      };

      const isConfirmed = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea guardar la información documentada al momento?`,
        'Sí',
        'No'
      );

      if (!isConfirmed) return;

      try {
        await inventoryCatalogService.editEquipment(this.equipmentId, payload);
        this.ShowToast(
          'Éxito',
          'Información ha sido editada exitosamente.',
          'success'
        );
        this.goBack();
      } catch (error) {
        this.ShowToast(
          'Error',
          error.response?.data?.message ?? error.message,
          'error'
        );
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
